import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import get from "@beeldit/core/services/get";
import { EditActionContext } from "./EditActionContext";

function useGet() {
  const { setElement, setShowModal } = useContext(EditActionContext);
  const errorHandler = useErrorHandler();

  return (
    id: any,
    formDefaultValues: any = {},
    onSuccess: any = (data: any) => {
      return data;
    }
  ) => {
    get("invoices", id, "?relations=invoice_lines,receiver_account")
      .then((response: any) => {
        let data = response.data;
        data = onSuccess(response.data);
        setElement({ ...formDefaultValues, ...data });
        setShowModal(true);
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useGet;
